import React, { useEffect, useState } from "react";
import AdminLayout from "@/components/layout/AdminLayout";
import api from "@/lib/api";

const STATUS_STYLE = {
  paid: "bg-emerald-100 text-emerald-800",
  initiated: "bg-amber-100 text-amber-800",
  pending: "bg-amber-100 text-amber-800",
  failed: "bg-red-100 text-red-800",
  expired: "bg-slate-200 text-slate-600",
};

export default function AdminPayments() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/admin/payments").then(({ data }) => setItems(data.items || []));
  }, []);

  const totalRevenue = items.filter((p) => p.status === "paid").reduce((acc, p) => acc + (p.amount || 0), 0);

  return (
    <AdminLayout>
      <div className="p-8 max-w-7xl">
        <div className="label-overline text-[#E63946]">Payments</div>
        <h1 data-testid="admin-payments-title" className="font-display text-4xl uppercase tracking-tighter mt-3">
          Payment Ledger
        </h1>

        <div className="mt-6 grid sm:grid-cols-3 gap-4">
          <div className="bg-white border border-slate-200 p-5">
            <div className="label-overline">Paid Transactions</div>
            <div className="font-data text-3xl mt-2">{items.filter((p) => p.status === "paid").length}</div>
          </div>
          <div className="bg-white border border-slate-200 p-5">
            <div className="label-overline">Pending</div>
            <div className="font-data text-3xl mt-2">{items.filter((p) => p.status !== "paid").length}</div>
          </div>
          <div className="bg-[#0A192F] text-white p-5">
            <div className="label-overline text-white/60">Total Revenue</div>
            <div className="font-data text-3xl mt-2">${totalRevenue.toFixed(2)}</div>
          </div>
        </div>

        <div className="mt-8 bg-white border border-slate-200 rounded-sm overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-slate-50 border-b border-slate-200">
                <th className="text-left p-4 label-overline">Date</th>
                <th className="text-left p-4 label-overline">Player</th>
                <th className="text-left p-4 label-overline">Camp</th>
                <th className="text-left p-4 label-overline">Amount</th>
                <th className="text-left p-4 label-overline">Status</th>
                <th className="text-left p-4 label-overline">Stripe Session</th>
              </tr>
            </thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.id} className="border-b border-slate-100 last:border-0">
                  <td className="p-4 text-xs">{new Date(p.created_at).toLocaleString("en-CA")}</td>
                  <td className="p-4">{p.player ? `${p.player.first_name} ${p.player.last_name}` : "—"}</td>
                  <td className="p-4">{p.camp?.title || "—"}</td>
                  <td className="p-4 font-data">${p.amount} {p.currency?.toUpperCase()}</td>
                  <td className="p-4">
                    <span className={`px-2 py-1 text-[10px] font-semibold uppercase tracking-wider ${STATUS_STYLE[p.status] || "bg-slate-100"}`}>
                      {p.status}
                    </span>
                  </td>
                  <td className="p-4 font-mono text-[11px] text-slate-500">{p.stripe_session_id?.slice(-16)}</td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td colSpan="6" className="p-10 text-center text-sm text-slate-500">No payments yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}
